import styled from '@emotion/styled';
import MuiButton from '@mui/material/Button';
import MuiDialogContent from '@mui/material/DialogContent';
import spacing from '@mui/system/spacing';

export const Button = styled(MuiButton)(spacing);
export const DialogContent = styled(MuiDialogContent)`
  overflow-y: auto;
`;
